import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import thunk from 'redux-thunk';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';

import logger from 'redux-logger';
import reducer from './redux/rating';

import { apiMiddleware } from 'redux-api-middleware';

import { State } from './assets/model.js';

// const middleware = applyMiddleware(logger, thunk);

const createStoreWithMiddleware = applyMiddleware(apiMiddleware, thunk, logger)(
  createStore
);

export default function configureStore(initialState) {
  return createStoreWithMiddleware(reducer, initialState);
}

const store = configureStore(State);

// const store = createStore(reducer, middleware);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js